import { RequestToPayBySaleIDQuery } from "@/API";
import { ISale, ISaleData } from "@/entities";
import { IRequestToPayData, IRequestToPay } from "@/entities/requestToPay";
import { IRequestToPayRepository } from "@/repositories/requestToPay";
import { IRequestToPayService } from "./requestToPay.types";

export class RequestToPayService implements IRequestToPayService {
    constructor(private repository: IRequestToPayRepository) {}

    // async getSaleById(id: string): Promise<ISale | undefined> {
    //     return (await this.repository.get(id));
    // }
    
    async getRequestToPay(id: string): Promise<IRequestToPay | undefined> {
        return await this.repository.get(id);
    }

    async createRequestToPay(data: IRequestToPayData): Promise<IRequestToPay> {
        return await this.repository.create(data);
    }

    async listRequestToPayBySaleID(id: string, nextToken: string | null | undefined): Promise<RequestToPayBySaleIDQuery> {
        return await this.repository.listRequestToPayBySaleID(id, nextToken);
    }

    async getRequestToPayByOrderID(orderID: string): Promise<IRequestToPay | undefined> {
        return await this.repository.getRequestToPayByOrderID(orderID);
    }

    async sendSMS(payload: any): Promise<void> {
        console.log("sendSMS service");
        return await this.repository.sendSMS(payload);
    }

    async sendEmail(payload: any): Promise<void> {
        console.log("sendEmail service");
        return await this.repository.sendEmail(payload);
    }
    // async syncSale(userData: ISaleData): Promise<ISale> {
    //     const user = await this.getSaleById(userData.id as string);
    //     if(user){
    //         return user;
    //     }
    //     return await this.createSale(userData);
    // }
}
